"use client";

import { useRouter } from "next/navigation";
import { useTopLoader } from "nextjs-toploader";
import type { Route } from "next";

type Navigate = {
    (href: string): void;
    replace: (href: string) => void;
    back: () => void;
};

export const useNavigate = (): Navigate => {
    const router = useRouter();
    const loader = useTopLoader();

    const navigate = Object.assign(
        (href: string) => {
            loader.start();
            router.push(href as Route);
        },
        {
            replace: (href: string) => {
                loader.start();
                router.replace(href as Route);
            },
            back: () => {
                loader.start();
                router.back();
            },
        },
    );

    return navigate;
};
